import { render } from "./evaluate.vue?vue&type=template&id=5e465488&scoped=true"
import script from "./evaluate.vue?vue&type=script&lang=js"
export * from "./evaluate.vue?vue&type=script&lang=js"

import "./evaluate.vue?vue&type=style&index=0&id=5e465488&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e465488"]])

export default __exports__